// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>
import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import MediaQuery from 'react-responsive';
import { ArrowBackIos } from '@material-ui/icons';
import PropTypes from 'prop-types';

import { Form } from '../components';
import styles from './styles';
import Navigation from '../../../common/Navigation/Navigation';

const LoginPage = ({ history, classes }) => {
  const locationState = history.location.state || {};
  return (
    <Navigation mobileLikeIndex={false}>
      <div className={classes.mainContainer}>
        <div className={classes.imageContainer}>
          <div className={classes.subContainer}>
            <div
              role={'button'}
              tabIndex={0}
              onKeyPress={() => history.goBack()}
              onClick={() => history.goBack()}
              className={classes.arrowBackContainer}
            >
              <ArrowBackIos />
              <MediaQuery minWidth={900}>
                {matches => (matches
                  ? (<div className={classes.link}>Back</div>)
                  : null)}
              </MediaQuery>
            </div>
            <h6 className={classes.title}>SIGN IN / REGISTER</h6>
            <Form
              history={history}
              toCheckout={locationState.checkout || false}
              tokenError={locationState.tokenError || false}
              message={locationState.message}
            />
          </div>
        </div>
      </div>
    </Navigation>);
};

LoginPage.propTypes = {
  classes: PropTypes.any,
  history: PropTypes.any,
};

LoginPage.defaultProps = {
  classes: {},
  history: {},
};

export default withStyles(styles)(LoginPage);
